import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Notification } from '../entities/notification.entity';

export interface NotificationRealtimePort {
  /** Emite cada notificación entrante en tiempo real (push del servidor). */
  readonly notification$: Observable<Notification>;
  /** Emite el conteo de no leídas cada vez que el servidor lo recalcula. */
  readonly unreadCount$: Observable<number>;

  /** Activa la conexión WebSocket/STOMP (idempotente). */
  connect(): void;
  /** Cierra la conexión WebSocket/STOMP (idempotente). */
  disconnect(): void;
}

export const NOTIFICATION_REALTIME_PORT =
  new InjectionToken<NotificationRealtimePort>('NOTIFICATION_REALTIME_PORT');
